// Hardcoded API URL to ensure it works
const API_URL_KEY = 'https://astrotellers.rankingeek.org';
const API_URL_KEY_LOCAL = 'http://localhost:3008';
export const API_END_POINT = `${API_URL_KEY}/api/v1/`;
export const API_URL = `${API_URL_KEY}/`;
export const API_ADMIN_END_POINT = `${API_URL_KEY}/api/v1/admin/`;